import React from 'react';
import { arrayOf, string, number, shape } from 'prop-types';
import {
  Table, TableBody, TableHead, TableRow
} from '@thd-olt-component-react/core-ui';
import { Image } from '@thd-olt-component-react/image';
import styles from './article-section.module.scss';

const BUYING_GUIDE = 'ab';
const ComparisonTable = ({ fields, articleType }) => {
  const fieldsObject = fields.map((field) => field.description);
  const products = fields.map((field) => field.product);
  if (articleType !== BUYING_GUIDE) return null;
  let className = styles.comparisonTable;
  return (
    <Table name="ComparisonTable" className={className}>
      <TableHead />
      <TableBody>
        <TableRow classNames={styles.comparisonTable__tr}>
          {products.map(({ image, title, url }, index) => {
            return (
              <td key={index} className={styles.comparisonTable__td1} style={{ textAlign: 'center !important' }}>
                <a href={url}>
                  <Image
                    src={image}
                    alt={title}
                    title={title}
                    width={180}
                    height={180}
                  />
                </a>
                <div className={styles.comparisonTable__title}>
                  {title}
                </div>
              </td>
            );
          }
          )}
        </TableRow>
        <TableRow classNames={styles.comparisonTable__tr}>
          {fieldsObject.map((field, index) => {
            return (
              <td key={field + index} className={styles.comparisonTable__td2}>
                {field}
              </td>
            );
          })}
        </TableRow>

      </TableBody>

    </Table>
  );

};

ComparisonTable.propTypes = {
  fields: arrayOf(shape({
    description: string,
    product: arrayOf(shape({
      description: string,
      id: string,
      image: string,
      quantity: number,
      title: string,
      url: string,
    })),
  })),
  articleType: string
};

ComparisonTable.defaultProps = {
  articleType: '',
  fields: [],
};
export { ComparisonTable };
